import * as React from "react";
import { useDataLoader } from "react-remote-data-hooks";
import api from "../../../api";
import { FilterValue, SortOrder, User } from "../../api";
import { IListFilterProps } from "./props";
import noImage from "../../../assets/images/user-noimage.png";
import { UserAvatar } from "../../../components/render-file/UserAvatar";

interface ICrmAgentFilterProps<T = any> extends IListFilterProps<T> {
  value?: FilterValue;
}

const CrmAgentFilter: React.FunctionComponent<ICrmAgentFilterProps> = (
  props
) => {
  const { data } = useDataLoader<User[]>(() =>
    api.user.getCrmAgents({
      sortBy: "name",
      sortOrder: SortOrder.ASC,
    })
  );
  const [search, setSearch] = React.useState("");
  const list = search
    ? data?.filter((us) => us.name?.match(new RegExp(search, "si")))
    : data;

  const onClose = () => {
    setSearch("");
    props.onClose?.();
  };

  const renderCrmAgent = (item: User) => {
    return (
      <div
        onClick={() =>
          props.applyFilter?.({ label: item.name!, value: item._id! })
        }
        className="custom-dropdown__menu-item border-bottom d-flex align-items-center cursor-pointer"
      >
        <div className="avatar-progress avatar-progress--xs position-relative cursor-pointer">
          <svg>
            <circle r="12" cx="50%" cy="50%" className="default"></circle>
            <circle
              r="12"
              cx="50%"
              cy="50%"
              className="progress"
              stroke-dasharray="117"
              stroke-dashoffset="75"
            ></circle>
          </svg>
          <UserAvatar
            id={item?._id}
            imageUrl={item?.avatar?.location}
            className="position-absolute left-0 right-0 top-0 bottom-0 m-auto rounded-circle"
            image={item.avatar}
          ></UserAvatar>
        </div>
        <div className="font-normal font-weight-semibold pl-2">
          {item.name || `${item?.firstName || ""} ${item?.lastName || ""}`}
        </div>
      </div>
    );
  };
  const renderUnassigned = () => {
    return (
      <div
        onClick={() =>
          props.applyFilter?.({ label: "Unassigned", value: null })
        }
        className="custom-dropdown__menu-item border-bottom d-flex align-items-center cursor-pointer"
      >
        <div className="avatar-progress avatar-progress--xs position-relative cursor-pointer">
          <svg></svg>
          <img
            src={noImage}
            className="position-absolute left-0 right-0 top-0 bottom-0 m-auto rounded-circle"
            alt="user"
          />
        </div>
        <div className="font-normal font-weight-semibold pl-2">Unassigned</div>
      </div>
    );
  };
  return (
    <div className="custom-dropdown__menu custom-dropdown__menu--open border overflow-auto w-100  bg-white zIndex-1">
      <div className="d-flex align-items-center justify-content-between bg-primary px-3 py-2 text-white mb-3">
        <h6 className="m-0 font-xs font-weight-semibold">{props.label}</h6>
        <span
          className="cursor-pointer d-inline-block text-center rounded-circle sub-dropdown-back ml-3"
          onClick={onClose}
        >
          <i className="icon-close font-xxs"></i>
        </span>
      </div>
      <div className="custom-dropdown__search border bg-gray-100 d-flex mb-2 position-sticky top-0 zIndex-1">
        <button
          type="submit"
          className="bg-transparent border-0 px-2 text-gray-600 d-flex align-items-center"
        >
          <i className="icon-search"></i>
        </button>
        <input
          type="text"
          className="form-control bg-transparent border-0 py-0 px-1 font-weight-semibold font-normal"
          placeholder="Search Support Executive"
          onChange={(e) => setSearch(e.target.value)}
          ref={(input) => input && input.focus()}
        />
      </div>
      {!search && renderUnassigned()}
      {list?.map(renderCrmAgent)}
    </div>
  );
};

export default CrmAgentFilter;
